/*
 * Bisiness units treeview component
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { BusinessUnit } from 'app/shared/models/business-unit.model';
import { NotificationService } from 'app/shared/services/notification.service';

@Component ( {
    selector: 'reporter-business-units-tree-view',
    templateUrl: './business-units-tree-view.component.html',
    styleUrls: ['./business-units-tree-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [NotificationService],
    standalone: false
} )
export class BusinessUnitsTreeViewComponent implements OnChanges {

  @Input () active = false;
  @Input () reportingCapable = false;
  @Input () buId: string;
  @Input () rootBuId: string;
  @Input () activeDate: string;
  @Output () selectBu = new EventEmitter<BusinessUnit> ();

  activeTab: 'tree-view' | 'search' = 'search';

  constructor(
    private notificationService: NotificationService,
  ) {
  }

  ngOnChanges( changes: SimpleChanges ) {
    if ( changes.active?.currentValue && !changes.active?.previousValue ) {
      if ( this.rootBuId || this.buId ) {
        setTimeout ( () => {
          this.switchTab ( 'tree-view' );
        } );
      } else {
        this.switchTab ( 'search' );
      }
    }
  }

  switchTab( newTab: 'tree-view' | 'search' ) {
    this.notificationService.clearAll ();
    this.activeTab = newTab;
  }

  close( bu: BusinessUnit ) {
    this.selectBu.emit ( bu );
  }
}
